import { useQuery } from '@tanstack/react-query';
import { getStatsOverview } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';

export const useStatsOverview = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: queryKeys.dmAutomation.statsOverview(),
        queryFn: getStatsOverview,
        enabled: options?.enabled ?? true,
    });
};
